import React, { memo } from 'react';
import { ActionButton, Item, Menu, MenuTrigger } from '@adobe/react-spectrum';
import S2IconMore from 'app/assets/icons/S2_Icon_More_20_N.svg';
import 'app/components/TimelineCard/ContextMenu.module.scss';
import styles from '../MonthlyRoadmap.module.scss';

interface MonthlyMomentContextMenuProps {
  onAction: (action: string | number) => void;
  onOpenChange?: (isOpen: boolean) => void;
}

export const MonthlyMomentContextMenu = memo(
  ({ onAction, onOpenChange }: MonthlyMomentContextMenuProps) => (
    <MenuTrigger
      align="end"
      direction="bottom"
      shouldFlip={true}
      onOpenChange={onOpenChange}
    >
      <ActionButton
        aria-label="More actions"
        isQuiet
        UNSAFE_className={styles.monthlyMomentMenuButton}
      >
        <img
          src={S2IconMore}
          alt="More options"
          className={styles.monthlyMomentMenuIcon}
        />
      </ActionButton>
      <Menu
        onAction={onAction}
        UNSAFE_style={{
          zIndex: 3,
          background: '#FFFFFF',
          border: 'none',
          borderRadius: '6px',
          boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.2)',
          padding: '10px',
          minWidth: '140px',
          maxWidth: '200px'
        }}
        UNSAFE_className="custom-context-menu"
      >
        <Item key="edit">Edit</Item>
        <Item key="delete">Delete</Item>
        <Item key="markComplete">Mark as Complete</Item>
      </Menu>
    </MenuTrigger>
  )
);
